import "./User.scss";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import {
  UserAddressColumns,
  UserRatesColumns,
  VendorsOrdersColumns,
} from "../../SourceData";
import UserImg from "./../../assets/user-img.png";
import FactoriesProductsGif from "./../../assets/factories-products-gif.gif";
import AddressLocation from "./../../assets/location-icon.png";
import DeleteUser from "./../../assets/delete.svg";
import ViewUser from "./../../assets/show-user.svg";
import GreenButton from "../../components/GreenButton/GreenButton";
import MessageModals from "../../components/MessageModals/MessageModals";
import { useMediaQuery } from "@mui/material";
import SwipeableModals from "./SwipeableModals/SwipeableModals";
import api from "../../utils/api";
import Loader from "../../components/Loader";
import LocationMapDialog from "../../components/LocationMapDialog/LocationMapDialog";

const User = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const [openDelete, setOpenDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [view, setView] = useState("shops");
  const [currentModalView, setCurrentModalView] = useState("userRates");
  const [isOpen, setIsOpen] = useState(false);
  const [locationDialogOpen, setLocationDialogOpen] = useState(false);
  const [user, setUser] = useState("");
  const [selectedAddress, setSelectedAddress] = useState("");
  const [selected, setSelected] = useState("");
  const { id } = useParams();
  useEffect(() => {
    getUser();
  }, [id]);

  const getUser = async () => {
    try {
      setLoading(true);
      const res = await api.get(`/users/${id}`);
      setUser(res.data.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleCloseLocationDialog = () => {
    setLocationDialogOpen(false);
    setSelectedAddress("");
  };

  const handleLocationClick = (row) => {
    setLocationDialogOpen(true);
    setSelectedAddress(row);
  };

  const handleOpen = (view) => {
    setCurrentModalView(view);
    setIsOpen(true);
  };
  const handleClose = () => setIsOpen(false);

  const actionColumn = [
    {
      field: "action",
      headerName: "",
      width: 100,
      headerAlign: "center",
      align: "center",

      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="cell-action">
            <div className="cell-btn">
              {view === "address" ? (
                <img
                  src={AddressLocation}
                  alt=""
                  onClick={() => handleLocationClick(params.row)}
                />
              ) : (
                <img
                  src={ViewUser}
                  alt=""
                  onClick={() => handleOpen("userRates")}
                />
              )}
            </div>

            <div
              className="cell-btn"
              onClick={() => {
                setOpenDelete(true);
                setSelected(params.row);
              }}
            >
              <img src={DeleteUser} alt="" />
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="user">
          <div className="user-header">
            <div className="user-info">
              <div className="info-container">
                <p className="title">تفاصيل المستخدم</p>
                <div className="info">
                  <img src={user?.img || UserImg} alt="" />
                  <div className="wrapper">
                    <p className="name">{user?.name}</p>
                    <span className="phone">{user?.phone}</span>
                  </div>
                </div>
              </div>

              <Link className="widget">
                <div
                  className="icon-container"
                  style={{ backgroundColor: "#ECF9FF" }}
                >
                  <img
                    src={FactoriesProductsGif}
                    alt=""
                    className="widget-icon"
                  />
                </div>
                <div className="widget-text-container">
                  <p className="number">{user?.orders_count}</p>
                </div>

                <span className="widget-title">الطلبات المكتملة</span>
              </Link>
            </div>

            <div className="btns-container">
              <GreenButton
                text="طلبات المتاجر"
                size={isMobile ? "full" : "medium"}
                variant={view === "shops" ? "fill" : "outlined"}
                onClick={() => setView("shops")}
              />

              <GreenButton
                text="طلبات المصانع"
                size={isMobile ? "full" : "medium"}
                variant={view === "factories" ? "fill" : "outlined"}
                onClick={() => setView("factories")}
              />

              <GreenButton
                text="العناوين"
                size={isMobile ? "full" : "small"}
                variant={view === "address" ? "fill" : "outlined"}
                onClick={() => setView("address")}
              />

              <GreenButton
                text="التقييمات"
                size={isMobile ? "full" : "small"}
                variant={view === "rates" ? "fill" : "outlined"}
                onClick={() => setView("rates")}
              />
            </div>
          </div>

          {view === "shops" && (
            <div className="container">
              <DataGrid
                sx={{ backgroundColor: "white", width: "100%" }}
                autoHeight={true}
                columns={VendorsOrdersColumns}
                rows={user?.vendors_orders?.map((row, index) => {
                  return { ...row, index: index + 1 };
                })}
                disableVirtualization
                disableColumnFilter
                disableColumnMenu
                hideFooter
                rowHeight={60}
              />
            </div>
          )}

          {view === "factories" && (
            <div className="container">
              <DataGrid
                sx={{ backgroundColor: "white", width: "100%" }}
                autoHeight={true}
                columns={VendorsOrdersColumns}
                rows={user?.factory_orders?.map((row, index) => {
                  return { ...row, index: index + 1 };
                })}
                disableVirtualization
                disableColumnFilter
                disableColumnMenu
                hideFooter
                rowHeight={60}
              />
            </div>
          )}

          {view === "address" && (
            <div className="container">
              <DataGrid
                sx={{ backgroundColor: "white", width: "100%" }}
                autoHeight={true}
                columns={UserAddressColumns.concat(actionColumn)}
                rows={user?.address?.map((row, index) => {
                  return { ...row, index: index + 1 };
                })}
                disableVirtualization
                disableColumnFilter
                disableColumnMenu
                hideFooter
                rowHeight={60}
              />
            </div>
          )}

          {view === "rates" && (
            <div className="container">
              <DataGrid
                sx={{ backgroundColor: "white", width: "100%" }}
                autoHeight={true}
                columns={UserRatesColumns.concat(actionColumn)}
                rows={user.comments.map((row, index) => {
                  return { ...row, index: index + 1 };
                })}
                disableVirtualization
                disableColumnFilter
                disableColumnMenu
                hideFooter
                rowHeight={60}
              />
            </div>
          )}

          <MessageModals
            open={openDelete}
            currentView="delete"
            route={`/address/${selected.id}`}
            text="تم مسح العنوان بنجاح"
            onClose={() => {
              setOpenDelete(false);
            }}
            onDataChange={() => {
              setOpenDelete(false);
              getUser();
            }}
          />
          <SwipeableModals
            open={isOpen}
            onClose={handleClose}
            onOpen={handleOpen}
            currentView={currentModalView}
          />

          <LocationMapDialog
            open={locationDialogOpen}
            onClose={handleCloseLocationDialog}
            lat={selectedAddress?.lat}
            lng={selectedAddress?.lng}
            address={selectedAddress?.address}
            customerName={user?.name}
          />
        </div>
      )}
    </>
  );
};

export default User;
